module.exports = __webpack_public_path__ + "assets/student.7c13d260.svg";